import React, { useState, useEffect } from "react";
import FloatingInputBox from "@components/FloatingInputBox";
import logo from "@images/yuldo_logo.png";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from '@utils/axiosInstance';
import { useDispatch } from 'react-redux';
import { setMessage } from '@store/messageSlice';
import '@css/LogIn.css';

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formState, setFormState] = useState({
    userId: "",
    password: "",
    rememberMe: false,
  });

  const [socket, setSocket] = useState(null); // WebSocket 상태 추가
  const [connected, setConnected] = useState(false); // WebSocket 연결 상태

  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    const savedUserId = localStorage.getItem("rememberedId");

    if (userInfo) {
      navigate("/main");
    }

    if (savedUserId) {
      setFormState(prevState => ({
        ...prevState,
        userId: savedUserId,
        rememberMe: true,
      }));
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormState(prevState => ({
      ...prevState,
      [id]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //일단 율도 밖에 없어서 주석 처리
    // const companyCode = localStorage.getItem('companyCode');

    // if (!companyCode) {
    //   dispatch(
    //     setMessage({
    //       message: '회사 코드가 없습니다. </br> 초기화면으로 이동합니다.',
    //       type: 'info'
    //     })
    //   );
    //   navigate('/');
    //   return;
    // }

    const { userId, password, rememberMe } = formState;

    if (rememberMe) {
      localStorage.setItem("rememberedId", userId);
    } else {
      localStorage.removeItem("rememberedId");
    }

    try {
      // const response = await axiosInstance.post('/api/auth/login', {
      //   companyCode: companyCode,
      //   loginId: userId,
      //   password: password,
      // });

      const response = await axiosInstance.post('/api/auth/yuldo-login', {
        loginId: userId,
        password: password,
      });

      if (response.data) {
        localStorage.setItem("userInfo", JSON.stringify(response.data));
        localStorage.setItem("companyCode", JSON.stringify(response.data.companyCode));
        connectWebSocket(response.data.token); // 로그인 성공 후 WebSocket 연결
        navigate("/main");
      }

    } catch (error) {
      console.log(error);
    }

  };

  const connectWebSocket = (token) => {
    const ws = new WebSocket(import.meta.env.VITE_APP_WS_URL);
    ws.onopen = () => {
      console.log('WebSocket 연결 성공');

      // WebSocket 연결 후 바로 인증 메시지 전송
      const authMessage = {
        type: 'AUTH',
        token: token
      };
      ws.send(JSON.stringify(authMessage));

      setSocket(ws);
      setConnected(true);
    };

    ws.onclose = (event) => {
      // 중복 로그인
      if (event.code === 1000) {
        const companyCode = localStorage.getItem("companyCode");
        const userInfo = localStorage.getItem("userInfo");

        if (companyCode) localStorage.removeItem("companyCode");
        if (userInfo) localStorage.removeItem("userInfo");

        dispatch(
          setMessage({
            message: event.reason
          })
        );
      } else if (event.code === 1006) {
        dispatch(
          setMessage({
            message: '업데이트 또는 네트워크 문제일 수 있습니다. <br> 잠시 후 페이지를 새로고침하여 다시 접속해 주세요.'
          })
        );
      }
    };

    ws.onerror = (error) => {
      console.error('WebSocket 에러:', error);

      dispatch(
        setMessage({
          message: error,
          type: error
        })
      );
    };
  };

  return (
    <div className="form-signin w-100 m-auto">
      <form onSubmit={handleSubmit}>
        <img className="mb-4" src={logo} alt="" width="100%" height="100%" />
        <FloatingInputBox
          id="userId"
          placeholder="아이디"
          label="아이디"
          value={formState.userId}
          onChange={handleChange}
          autoComplete="username"
        />
        <FloatingInputBox
          id="password"
          type="password"
          placeholder="비밀번호"
          label="비밀번호"
          value={formState.password}
          onChange={handleChange}
          autoComplete="current-password"
        />
        <div className="form-check text-start my-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="rememberMe"
            checked={formState.rememberMe}
            onChange={handleChange}
          />
          <label className="form-check-label" htmlFor="rememberMe">
            Remember me
          </label>
        </div>
        <button id="sign-in-btn" className="btn btn-primary w-100 py-2">Sign in</button>
      </form>
    </div>
  );
}
